export default "__VITE_ASSET__BxpMZSfw__"